import React, { FC } from "react";
import { Loader } from "./Loader.component";

import "./AppLoader.component.scss";

export const AppLoader: FC = () => (<div className="app-loader"><Loader /></div>);
